import React, { Component } from 'react';
import MapIcon from '@mui/icons-material/Map';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import styles from './baselayerMapControl.module.scss';
import TooltipWrapper from '../../shared/items/contols/tooltipWrapper';
import { withMapControl } from '../../shared/containers/containerMapControl';
import { CRS } from 'leaflet';
import { Checkbox } from '@material-ui/core';
import { withAuth } from '../../shared/containers/containerAuth';
import configuration from './../../config.json';

class BaseLayerMapControl extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  setOsm() {
    console.log(
      configuration.isLocalApp &&
        configuration.localAppConfig.localMapTilesUrl !== null,
    );

    const baseLayer = {
      name: 'Osm',
      crs: CRS.EPSG900913,
      url: [
        configuration.isLocalApp &&
        configuration.localAppConfig.localMapTilesUrl !== null
          ? configuration.localAppConfig.localMapTilesUrl
          : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      ],
      maxZoom: 19,
    };

    this.props.onSetBaselayer(baseLayer);
  }

  setYandex() {
    const baseLayer = {
      name: 'Yandex',
      crs: CRS.EPSG3395,
      maxZoom: 19,
      url: [
        'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&v=21.12.02-1-b211103130830&x={x}&y={y}&z={z}&lang=ru_RU',
      ],
    };

    this.props.onSetBaselayer(baseLayer);
  }

  setYandexSat() {
    const baseLayer = {
      name: 'YandexSat',
      crs: CRS.EPSG3395,
      maxZoom: 19,
      url: [
        'https://core-sat.maps.yandex.net/tiles?l=sat&v=3.928.0&x={x}&y={y}&z={z}&lang=ru_RU',
      ],
    };

    this.props.onSetBaselayer(baseLayer);
  }

  setYandexHybrid() {
    const baseLayer = {
      name: 'YandexHybrid',
      crs: CRS.EPSG3395,
      maxZoom: 19,
      url: [
        'https://core-sat.maps.yandex.net/tiles?l=sat&v=3.928.0&x={x}&y={y}&z={z}&lang=ru_RU',
        'https://core-renderer-tiles.maps.yandex.net/tiles?l=skl&v=21.12.02-1-b211103130830&x={x}&y={y}&z={z}&lang=ru_RU',
      ],
    };

    this.props.onSetBaselayer(baseLayer);
  }

  setArcGisSat() {
    const baseLayer = {
      name: 'ArcGisSat',
      crs: CRS.EPSG900913,
      maxZoom: 17,
      url: [
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      ],
    };

    this.props.onSetBaselayer(baseLayer);
  }

  setCartocdn() {
    const baseLayer = {
      name: 'cartocdn',
      crs: CRS.EPSG900913,
      maxZoom: 17,
      url: ['http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png'],
    };

    this.props.onSetBaselayer(baseLayer);
  }

  viewCustomMap() {
    const { isViewCustomMap, onViewCustomMap } = this.props;

    onViewCustomMap(!isViewCustomMap);
  }

  render() {
    const { mapBaseLayer, isViewCustomMap, data } = this.props;
    const { isOpen } = this.state;

    const onlyLocalMapTiles =
      configuration.isLocalApp &&
      configuration.localAppConfig.onlyLocalMapTiles;

    return (
      <div className={styles.baselayer_control_container}>
        {isOpen ? (
          <div className={styles.baseLayerItemContent}>
            <TooltipWrapper title={'Закрыть панель карт'} position="left">
              <div
                className={styles.baselayersIconControlClose}
                onClick={() => this.setState({ isOpen: false })}
              >
                <HighlightOffIcon fontSize="small" />
              </div>
            </TooltipWrapper>

            <div
              className={
                mapBaseLayer.name === 'Osm'
                  ? styles.checkbox_baselayer
                  : styles.checkbox_baselayer_disable
              }
              onClick={this.setOsm.bind(this)}
            >
              <span>OpenStreetMap</span>
            </div>
            {!onlyLocalMapTiles ? (
              <div>
                {' '}
                <div
                  className={
                    mapBaseLayer.name === 'Yandex'
                      ? styles.checkbox_baselayer
                      : styles.checkbox_baselayer_disable
                  }
                  onClick={this.setYandex.bind(this)}
                >
                  <span>Yandex</span>
                </div>
                <div
                  className={
                    mapBaseLayer.name === 'YandexSat'
                      ? styles.checkbox_baselayer
                      : styles.checkbox_baselayer_disable
                  }
                  onClick={this.setYandexSat.bind(this)}
                >
                  <span>Yandex спутник</span>
                </div>
                <div
                  className={
                    mapBaseLayer.name === 'YandexHybrid'
                      ? styles.checkbox_baselayer
                      : styles.checkbox_baselayer_disable
                  }
                  onClick={this.setYandexHybrid.bind(this)}
                >
                  <span>Yandex гибрид</span>
                </div>
                <div
                  className={
                    mapBaseLayer.name === 'ArcGisSat'
                      ? styles.checkbox_baselayer
                      : styles.checkbox_baselayer_disable
                  }
                  onClick={this.setArcGisSat.bind(this)}
                >
                  <span>ArcGis спутник</span>
                </div>
                {/*  <div
                  className={
                    mapBaseLayer.name === 'cartocdn'
                      ? styles.checkbox_baselayer
                      : styles.checkbox_baselayer_disable
                  }
                  onClick={this.setCartocdn.bind(this)}
                >
                  <span>Cartocdn</span>
                </div> */}
              </div>
            ) : null}

            {mapBaseLayer.crs === CRS.EPSG900913 &&
            data.permissions.includes(44001) ? (
              <div>
                <div
                  className={
                    isViewCustomMap
                      ? styles.checkbox_baselayer
                      : styles.checkbox_baselayer_disable
                  }
                >
                  <Checkbox
                    style={{
                      width: '5px',
                      height: '5px',
                      paddingRight: '13px',
                    }}
                    checked={isViewCustomMap}
                    onChange={this.viewCustomMap.bind(this)}
                    color={'primary'}
                  />
                  <span>Пользовательская карта</span>
                </div>
              </div>
            ) : null}
          </div>
        ) : (
          <TooltipWrapper title={'Открыть панель карт'} position="left">
            <div
              className={styles.baselayersIconControl}
              onClick={() => this.setState({ isOpen: true })}
            >
              <MapIcon />
            </div>
          </TooltipWrapper>
        )}
      </div>
    );
  }
}

export default withAuth(withMapControl(BaseLayerMapControl));
